import { projects } from "../data/projects";
import ProjectCard from "../components/ProjectCard";

export default function Projects() {
    return (
        <div data-testid="projects-page">
            <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12 md:pb-20">
                <div className="overline mb-4 fade-up">Projekt-arkiv</div>
                <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] text-[#2C241B] max-w-4xl fade-up fade-up-delay-1">
                    Hver opgave har sin<br />
                    <span className="italic text-[#2F483A]">egen historie.</span>
                </h1>
                <p className="mt-8 max-w-2xl text-lg text-[#4A3B2C] font-light leading-relaxed fade-up fade-up-delay-2">
                    Her samler vi opgaverne som de kommer fra værkstedet —
                    store som små. Kvalitetshåndværk uden kompromis. Klik på
                    et projekt for at se billeder, detaljer og links til de
                    oprindelige opslag på Facebook og Instagram.
                </p>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
                {projects.length === 0 ? (
                    <div className="border border-dashed border-[#D1C7B7] rounded-sm p-16 text-center text-[#7A6855]">
                        Ingen projekter tilføjet endnu.
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
                        {projects.map((p, i) => {
                            // Alternate column widths for editorial feel
                            const spans = [
                                "md:col-span-7",
                                "md:col-span-5",
                                "md:col-span-5",
                                "md:col-span-7",
                                "md:col-span-6",
                                "md:col-span-6",
                            ];
                            return (
                                <div
                                    key={p.slug}
                                    className={`${spans[i % spans.length]} ${
                                        i % 3 === 1 ? "md:mt-16" : ""
                                    }`}
                                >
                                    <ProjectCard project={p} index={i} />
                                </div>
                            );
                        })}
                    </div>
                )}
            </section>
        </div>
    );
}
